import React from 'react';
import styled from 'styled-components';
import { themed } from '@heathmont/moon-utils';
const Svg = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 4 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 4H0V0h4v12zm0 16H0V8h4v12z", fill: "currentColor", fillRule: "nonzero" })));
const IconInfo = styled(Svg).withConfig({
    shouldForwardProp: prop => !['backgroundColor', 'circleColor', 'color'].includes(prop),
})(({ backgroundColor, circleColor, color, theme }) => [
    backgroundColor && {
        backgroundColor: themed('color', backgroundColor)(theme),
        padding: backgroundColor ? '0.25em' : 0,
        overflow: 'visible',
        borderRadius: '50%',
    },
    color && {
        color: themed('color', color)(theme),
    },
    circleColor && {
        circle: {
            fill: themed('color', circleColor)(theme),
        },
    },
]);
export default IconInfo;
